import { get } from "lodash";
/** First name field (`additional.patient_name.first`) or legacy full `name` (DICOM prefill). */
export function patientPrimaryName(patient) {
  return String(get(patient, ["additional", "patient_name", "first"], "") || patient.name || "").trim();
}

/**
 * Full display / payload `name`: structured parts joined.
 * Uses the same first-segment rule as LC first-name input: `first ?? name` (nullish only),
 * so legacy-only `name` is preserved when structured `first` is unset.
 */
export function patientFullDisplayName(patient) {
  var _ref;
  var rawFirst = get(patient, ["additional", "patient_name", "first"]);
  var firstPart = String((_ref = rawFirst !== null && rawFirst !== void 0 ? rawFirst : patient.name) !== null && _ref !== void 0 ? _ref : "").trim();
  var middlePart = String(get(patient, ["additional", "patient_name", "middle"], "") || "").trim();
  var lastPart = String(get(patient, ["additional", "patient_name", "last"], "") || "").trim();
  var parts = [firstPart, middlePart, lastPart].filter(Boolean);
  var joined = parts.join(" ");
  return joined || String(patient.name || "").trim();
}